'use client';
import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { useEffect } from 'react';
import { getDefaultPaymentMethod } from '../../helpers/getDefaultPaymentMethod.helper';
import { type PaymentSettings } from '../../types/paymentLink.types';
import { usePreselectVariant } from '../usePreselectVariant';

export function useAutoPreselectPaymentMethod(paymentSettings: PaymentSettings) {
  const {
    paymentMethod,
    selectedDigitalWallet,
    setPaymentMethod,
    setSelectedDigitalWallet,
    setPaymentWithClickToPay,
  } = usePaymentMethod();
  const { isLoading, skipPreselect } = usePreselectVariant();

  const acceptedPaymentMethods = paymentSettings.accepted_payment_methods;
  const isDebitCardOnly =
    acceptedPaymentMethods.length === 1 &&
    acceptedPaymentMethods[0] === 'debit_card';

  useEffect(() => {
    if (isLoading) return;
    if (paymentMethod || selectedDigitalWallet) return;

    if (isDebitCardOnly && paymentSettings.click_to_pay_enabled) {
      setSelectedDigitalWallet('clickToPay');
      setPaymentWithClickToPay(true);
      return;
    }

    const defaultPaymentMethod = getDefaultPaymentMethod(
      acceptedPaymentMethods,
      skipPreselect
    );
    if (defaultPaymentMethod) {
      setPaymentMethod(defaultPaymentMethod);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, skipPreselect]);
}
